import { SetSignalRSessionToChatSessionRequest } from "../../Model/Request/ClientUser/SetSignalRSessionToChatSessionRequest";
import { StartChatRequest } from "../../Model/Request/ClientUser/StartChatRequest";
import { SetSignalRSessionToChatSessionResponse } from "../../Model/Response/ClientUser/SetSignalRSessionToChatSessionResponse";
import { StartChatResponse } from "../../Model/Response/ClientUser/StartChatResponse";
import { ApiBaseResponse } from "../../Model/Response/Common/ApiBaseResponse";
import { GlobalOperations } from "../Common/GlobalOperations";

export async function StartChat(request: StartChatRequest): Promise<ApiBaseResponse<StartChatResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "api/ChatClientSide/StartChat",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<StartChatResponse> = await response.json();
    return data;
}


export async function SetSignalRSessionToChatSession(request: SetSignalRSessionToChatSessionRequest): Promise<ApiBaseResponse<SetSignalRSessionToChatSessionResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "api/ChatClientSide/SetSignalRSessionToChatSession",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<SetSignalRSessionToChatSessionResponse> = await response.json();
    return data;
}
